export default __webpack_public_path__ + "static/media/foto5.3d078e57.jpg";